export class RestoreAzureSqlDatabaseRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "AzureSqlDatabaseRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureSqlDatabaseRequest.attributeTypeMap;
    }
    constructor() {
    }
}
